import React from 'react'
import { useDispatch } from 'react-redux'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import {
  Box,
  Divider,
  Typography
} from '@mui/material'
import {
  reduceCartQuantity,
  removeFromCart
} from '@/modules/cart/cartSlice'
import { CartItem } from '@/modules/cart/types/cart'
import {
  getFeaturedImage,
  getPrice
} from '@/modules/product/utils'
import ChronoCard from '@/layouts/core/components/ChronoCard'
import ChronoLinkButton from '@/layouts/core/components/ChronoLinkButton'
import CartItemQuantity from '@/modules/cart/components/CartItemQuantity'
import CartItemShippingType from '@/modules/cart/components/CartItemShippingType'

const useStyles = makeStyles((theme: Theme) => ({
  productNameContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    },
  },
  productName: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px !important'
    },
  },
  productPrice: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px !important'
    },
  },
  cartControlsContainer: {
    alignItems: 'end',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'column',
      justifyContent: 'start',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
}))

type CartItemProps = {
  cartItem: CartItem,
  paper?: boolean
  mini?: boolean
  showQuantity?: boolean
}

const CartItemCard = ({ cartItem, paper, mini, showQuantity }: CartItemProps) => {
  const dispatch = useDispatch()
  const { product, option, quantity } = cartItem
  const { formatted: totalPrice } = getPrice({option, quantity})
  const featuredImage = getFeaturedImage(product)
  const classes = useStyles()

  const onRemoveFromCart = () => {
    dispatch(removeFromCart(cartItem))
  }
  const onReduceCartQuantity = () => {
    dispatch(reduceCartQuantity(cartItem))
  }

  return (
    <ChronoCard
      mini={mini}
      paper={paper !== false ? {
        elevation: 3
      } : undefined}
      image={{
        src: (featuredImage || ''),
        title: product.name,
        maxWidth: !mini ? undefined : 50
      }}
      content={
        <>
          <Box className={classes.productNameContainer}>
            <Typography className={classes.productName} variant={mini ? 'h6' : 'h4'}>{product.name}</Typography>
            <Typography className={classes.productPrice} variant={mini ? 'h6' : 'h4'}>{totalPrice}</Typography>
          </Box>

          <Divider style={{ marginTop: 15, marginBottom: 15 }} variant={'fullWidth'}/>

          <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
            
            <Box className={'ct-cart-opt-box'} display={'flex'} flexDirection={'column'} justifyContent={'start'}>
              <Box display={'flex'} flexDirection={'row'} justifyContent={'start'} marginBottom={1}>
                <Typography variant={'body1'} fontWeight={'bold'} marginRight={1}>Option:</Typography>
                <Typography variant={'body1'}>{option.name}</Typography>
              </Box>
              <Typography variant={'body1'}>SKU # {product.sku}</Typography>
            </Box>

            <Box className={classes.cartControlsContainer} display={'flex'} flexDirection={'column'} justifyContent={'start'}>
              <Box>
                <ChronoLinkButton
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 'bold'
                  }}
                  onClick={showQuantity !== false ? onRemoveFromCart : onReduceCartQuantity}>
                  Remove
                </ChronoLinkButton>
              </Box>

              {showQuantity !== false &&
                <Box 
                  width={'auto'} 
                  marginTop={2}
                  marginLeft={5} 
                  display={'flex'} 
                  flexDirection={'column'} 
                  justifyContent={'end'} 
                  alignItems={'end'}>
                  
                  <CartItemQuantity {...cartItem} autoUpdate={true} fullWidth={false}/>
                  <CartItemShippingType {...cartItem} autoUpdate={true} sx={{marginTop: 2}} />
                  
                </Box>
              }
            </Box>

          </Box>

        </>
      }
    />
  )
}

export default CartItemCard